export default __webpack_public_path__ + "images/how-to-badge.svg";